/* @flow */
import * as React from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import {
    PasswordExpiryNotification,
    PasswordExpiryNotificationTrigger
} from 'common/components/core/password';
import { DivWithPopover } from 'common/components/core/wrappers/Div';
import Icon from 'common/components/core/icon';
import { PopoverPlaceEnum } from 'common/components/core/popover/popOverFactory';
import {
    personnelDataSelector,
    sessionSelector
} from 'common/redux/selectors/sessionSelector';
import { Session } from 'common/models/internal/Session';
import { passwordExpiryNotificationVisibleSelector } from 'common/redux/selectors/password';

import defaultTheme from './UserMenuIcon.scss';

type Props = {
    session: ?Session,
    userPhoto: string,
    theme: Object,
    isPasswordExpiryNotificationVisible: ?boolean
};

class UserMenuIcon extends React.Component<Props> {
    hasErrors = () => {
        const { session } = this.props;
        return (
            session &&
            (session.isPasswordExpiringInNext7Days() ||
                session.isPasswordExpired())
        );
    };

    render() {
        const { props } = this;
        const photoStyle = { backgroundImage: `url(${props.userPhoto})` };
        return (
            <DivWithPopover
                className={props.theme.container}
                theme={props.theme}
                popOverContent={<PasswordExpiryNotification />}
                preferPlace={PopoverPlaceEnum.Below}
                invertPopover={false}
                isPopOverOpen={props.isPasswordExpiryNotificationVisible}
            >
                <div className={props.theme.accountIconWrap}>
                    <div
                        className={props.theme.accountIcon}
                        style={photoStyle}
                    />
                </div>
                {this.hasErrors() ? (
                    <Icon
                        icon="alert"
                        circular
                        className={props.theme.alertIcon}
                    />
                ) : null}

                <PasswordExpiryNotificationTrigger />
            </DivWithPopover>
        );
    }
}

export default compose(
    themr('UserMenuIcon', defaultTheme),
    connect(state => {
        const { photoUrl } = personnelDataSelector(state);
        return {
            userPhoto: photoUrl,
            session: sessionSelector(state),
            isPasswordExpiryNotificationVisible: passwordExpiryNotificationVisibleSelector(
                state
            )
        };
    })
)(UserMenuIcon);
